"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.SELECTION_TYPE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _iterator7 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2.js"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator7["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var SELECTION_TYPE = {
  LEAST_RECENTLY_USED: 'LEAST_RECENTLY_USED',
  DISTANCE: 'LEARNING_DISTANCE',
  RANDOM: 'RANDOM'
};
exports.SELECTION_TYPE = SELECTION_TYPE;
var mode = {
  LAST_SEEN: 'lastSeen',
  DISTANCE: 'distance'
};
var state = {};
var MAX_HISTORY = 100;

function getOrderedQuestionIds(_x, _x2, _x3, _x4) {
  return _getOrderedQuestionIds.apply(this, arguments);
}

function _getOrderedQuestionIds() {
  _getOrderedQuestionIds = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(amount, categoryId, subjectId, forceQuestionGroup) {
    var selectionTypeObj, distances, firstOrderField, secondOrderField, selectionType, _questionIds, order, sortedKeySet, doNotShowLearnedQuestions, groupData, questionIds, _iterator2, _step2, distance, _iterator3, _step3, entry;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(amount <= 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", []);

          case 2:
            selectionTypeObj = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_QUESTION_SELECTION_TYPE) || {
              name: SELECTION_TYPE.RANDOM
            };
            _context.next = 5;
            return getDistances(categoryId, subjectId);

          case 5:
            distances = _context.sent;
            // @ts-ignore
            selectionType = selectionTypeObj.name ? selectionTypeObj.name : SELECTION_TYPE.RANDOM;

            if (!(selectionType === SELECTION_TYPE.LEAST_RECENTLY_USED)) {
              _context.next = 12;
              break;
            }

            firstOrderField = mode.LAST_SEEN;
            secondOrderField = mode.DISTANCE;
            _context.next = 20;
            break;

          case 12:
            if (!(selectionType === SELECTION_TYPE.DISTANCE)) {
              _context.next = 17;
              break;
            }

            firstOrderField = mode.DISTANCE;
            secondOrderField = mode.LAST_SEEN;
            _context.next = 20;
            break;

          case 17:
            _questionIds = (0, _from["default"])(distances.keys());
            (0, _ArrayHelper.shuffle)(_questionIds);
            return _context.abrupt("return", _questionIds.slice(0, amount));

          case 20:
            order = new _map["default"]();
            distances.forEach(function (infoObj) {
              var distance = firstOrderField === mode.LAST_SEEN ? infoObj.lastSeen : infoObj.distance;

              if (!order.has(distance)) {
                order.set(distance, []);
              }

              order.get(distance).push(infoObj);
            });
            sortedKeySet = (0, _from["default"])(order.keys());
            sortedKeySet.sort(function (a, b) {
              if (a > b) return 1;else if (a < b) return -1;else return 0;
            }); // true has to be replaced by server flag doNotShowLearnedQuestions

            doNotShowLearnedQuestions = true;
            groupData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP); //@ts-ignore

            if (groupData && groupData.value && groupData.value.hasOwnProperty('noLearnedQuestions')) {
              //@ts-ignore
              doNotShowLearnedQuestions = groupData.value.noLearnedQuestions;
            }

            if (forceQuestionGroup) {
              doNotShowLearnedQuestions = false;
            }

            questionIds = [];
            _iterator2 = _createForOfIteratorHelper(sortedKeySet);
            _context.prev = 30;

            _iterator2.s();

          case 32:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 61;
              break;
            }

            distance = _step2.value;

            if (!(questionIds.length >= amount && doNotShowLearnedQuestions)) {
              _context.next = 36;
              break;
            }

            return _context.abrupt("break", 61);

          case 36:
            if (!order.has(distance)) {
              _context.next = 59;
              break;
            }

            (0, _ArrayHelper.shuffle)(order.get(distance));
            order.get(distance).sort(function (a, b) {
              var valA = secondOrderField === mode.LAST_SEEN ? a.lastSeen : a.distance;
              var valB = secondOrderField === mode.LAST_SEEN ? b.lastSeen : b.distance;

              if (secondOrderField === mode.LAST_SEEN) {
                if (valA < valB) return -1;
                if (valA > valB) return 1;
                return 0;
              } else {
                if (valA > valB) return -1;
                if (valA < valB) return 1;
                return 0;
              }
            });
            _iterator3 = _createForOfIteratorHelper(order.get(distance));
            _context.prev = 40;

            _iterator3.s();

          case 42:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 51;
              break;
            }

            entry = _step3.value;

            if (!(questionIds.length >= amount && !doNotShowLearnedQuestions)) {
              _context.next = 46;
              break;
            }

            return _context.abrupt("break", 51);

          case 46:
            if (!(doNotShowLearnedQuestions && entry.distance === 10)) {
              _context.next = 48;
              break;
            }

            return _context.abrupt("continue", 49);

          case 48:
            questionIds.push(entry.questionId);

          case 49:
            _context.next = 42;
            break;

          case 51:
            _context.next = 56;
            break;

          case 53:
            _context.prev = 53;
            _context.t0 = _context["catch"](40);

            _iterator3.e(_context.t0);

          case 56:
            _context.prev = 56;

            _iterator3.f();

            return _context.finish(56);

          case 59:
            _context.next = 32;
            break;

          case 61:
            _context.next = 66;
            break;

          case 63:
            _context.prev = 63;
            _context.t1 = _context["catch"](30);

            _iterator2.e(_context.t1);

          case 66:
            _context.prev = 66;

            _iterator2.f();

            return _context.finish(66);

          case 69:
            (0, _ArrayHelper.shuffle)(questionIds);
            return _context.abrupt("return", questionIds);

          case 71:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[30, 63, 66, 69], [40, 53, 56, 59]]);
  }));
  return _getOrderedQuestionIds.apply(this, arguments);
}

function initDistances(categoryId, subjectId) {
  var distances = new _map["default"]();
  var progressionGroups = new _map["default"]();
  var lastSeen = new Date(1970, 0, 1).getTime();
  var minCorrectsForLearned = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED) || 1;
  var path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_QUESTIONS, ".").concat(subjectId, ".").concat(categoryId);

  var questions = _DataStore["default"].getElementByPathImmediately(path);

  if (!questions || !(0, _isArray["default"])(questions)) {
    throw "QuizSelectionService init Distances: Unable to obtain questions ".concat(subjectId, " ").concat(questions);
  }

  if (questions.length > 0) {
    (0, _ArrayHelper.shuffle)(questions);

    var _iterator = _createForOfIteratorHelper(questions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var question = _step.value;
        var info = {
          distance: minCorrectsForLearned,
          lastSeen: lastSeen,
          questionId: question.id,
          progressionGroup: question.progressionGroup
        };
        distances.set(question.id, info);

        if (question.progressionGroup) {
          var group = progressionGroups.get(question.progressionGroup);

          if (group) {
            group.push(question);
            progressionGroups.set(question.progressionGroup, group);
          } else {
            progressionGroups.set(question.progressionGroup, [question]);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return {
    distances: distances,
    progressionGroups: progressionGroups
  };
}

function getHistoryForQuestion(questionId, categoryId, subjectId) {
  var path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId, ".").concat(questionId);

  var questionHistory = _DataStore["default"].getElementByPathImmediately(path);

  var minCorrectsForLearned = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED) || 1;
  var returnObj = {};
  var maxLength = 0;

  if (questionHistory) {
    if (questionHistory.progressionGroup && questionHistory.progressionLevel) {
      returnObj.progressionGroup = questionHistory.progressionGroup;
      returnObj.progressionLevel = questionHistory.progressionLevel;
      maxLength = getProgressionGroupLength(questionHistory.progressionGroup);
    }

    return (0, _assign["default"])({
      target: maxLength > 0 ? maxLength : minCorrectsForLearned,
      current: questionHistory.distance === 10 ? minCorrectsForLearned : minCorrectsForLearned - (questionHistory.distance + 1)
    });
  } else {
    return {
      target: minCorrectsForLearned,
      current: 0
    };
  }
}

function syncDistancesWithHistory(categoryId, subjectId, distances, progressionGroups) {
  // @ts-ignore
  var path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId);

  var historyMap = _DataStore["default"].getElementByPathImmediately(path);

  if (historyMap) {
    var _loop = function _loop() {
      var historyObj = _Object$values[_i];
      var info = distances.get(historyObj.question);

      if (info) {
        info.distance = historyObj.distance;
        var date = Date.parse(historyObj.dateCreated);

        if (isNaN(date)) {
          date = parseServerDate(historyObj.dateCreated);
        }

        if (!isNaN(date)) {
          info.lastSeen = date;
        } else {
          info.lastSeen = new Date(1970, 0, 1).getTime();
        }

        distances.set(info.questionId, info);

        if (info.progressionGroup) {
          var group = progressionGroups.get(info.progressionGroup);

          if (group) {
            var question = group.find(function (question) {
              return question.id === info.questionId;
            });

            if (question) {
              if (!question.learningDistance) {
                question.learningDistance = {};
              }

              question.learningDistance.history = historyObj.history;
              question.learningDistance.downgrade = historyObj.downgrade ? historyObj.downgrade : false;
            }
          }
        }
      }
    };

    for (var _i = 0, _Object$values = (0, _values["default"])(historyMap); _i < _Object$values.length; _i++) {
      _loop();
    }
  }
}

function sortQuestions(questions, distances) {
  return questions.sort(function (a, b) {
    if (a.progressionLevel > b.progressionLevel || a.progressionLevel < b.progressionLevel) {
      return a.progressionLevel - b.progressionLevel;
    } else if (a.progressionLevel === b.progressionLevel) {
      var infoA = distances.get(a.id);
      var infoB = distances.get(b.id);

      if (infoA && infoB) {
        if (infoA.distance > infoB.distance) {
          return -1;
        } else if (infoA.distance < infoB.distance) {
          return 1;
        } else {
          return 0;
        }
      }

      return 0;
    }
  });
}

function filterProgressionGroups(_x5, _x6, _x7, _x8) {
  return _filterProgressionGroups.apply(this, arguments);
}

function _filterProgressionGroups() {
  _filterProgressionGroups = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(distances, progressionGroups, categoryId, subjectId) {
    var _iterator4, _step4, _loop2;

    return _regenerator["default"].wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _iterator4 = _createForOfIteratorHelper(progressionGroups.entries());
            _context3.prev = 1;
            _loop2 = /*#__PURE__*/_regenerator["default"].mark(function _loop2() {
              var _step4$value, group, questions, sortedQuestions, questionIndex, _iterator5, _step5, _question, currentQuestion, path, questionHistory, minCorrectsForLearned, newQuestionIndex, questionsWithSameOrOneLowerProgressionLevel, questionId, _iterator6, _step6, _question2;

              return _regenerator["default"].wrap(function _loop2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _step4$value = (0, _slicedToArray2["default"])(_step4.value, 2), group = _step4$value[0], questions = _step4$value[1];
                      sortedQuestions = sortQuestions(questions, distances);
                      questionIndex = -1;
                      _iterator5 = _createForOfIteratorHelper(sortedQuestions);

                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                          _question = _step5.value;

                          if (_question.learningDistance && _question.learningDistance.history && _question.learningDistance.history.slice(-1) === 'R') {
                            questionIndex += 1;
                          }
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }

                      questionIndex = questionIndex !== sortedQuestions.length - 1 ? questionIndex + 1 : questionIndex;
                      currentQuestion = sortedQuestions[questionIndex];
                      /**
                       * If we find the current level question by just filtering the question history, we wont be able to downgrade since last answer of prev question is always R.
                       * To be able to downgrade we check the key 'downgrade' which indicates if we have to ask the lower level question or the higher level one.
                       */

                      if (!(currentQuestion.learningDistance && currentQuestion.learningDistance.downgrade && questionIndex > 0)) {
                        _context2.next = 19;
                        break;
                      }

                      path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId, ".").concat(currentQuestion.id);
                      questionHistory = _DataStore["default"].getElementByPathImmediately(path);

                      if (!questionHistory) {
                        _context2.next = 19;
                        break;
                      }

                      questionHistory.downgrade = false;
                      _context2.next = 14;
                      return _DataStore["default"].setSingleData(path, questionHistory);

                    case 14:
                      minCorrectsForLearned = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED) || 1;
                      newQuestionIndex = 0;
                      questionsWithSameOrOneLowerProgressionLevel = sortedQuestions.filter(function (question) {
                        return question.progressionLevel === currentQuestion.progressionLevel || question.progressionLevel === currentQuestion.progressionLevel - 1;
                      });
                      questionsWithSameOrOneLowerProgressionLevel.forEach(function (question) {
                        // @ts-ignore
                        if (question && question.learningDistance) {
                          var _path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId, ".").concat(question.id);

                          var _questionHistory = _DataStore["default"].getElementByPathImmediately(_path);

                          _questionHistory.history = '';
                          _questionHistory.distance = minCorrectsForLearned;

                          _DataStore["default"].setSingleData(_path, _questionHistory);
                        }

                        var questionInfo = distances.get(question.id);

                        if (questionInfo) {
                          questionInfo.distance = minCorrectsForLearned;
                          questionInfo.lastSeen = new Date(1970, 0, 1).getTime();
                          distances.set(question.id, questionInfo);
                        }

                        if (question.progressionLevel < currentQuestion.progressionLevel) {
                          newQuestionIndex = sortedQuestions.indexOf(question);
                        }
                      });
                      currentQuestion = questions[newQuestionIndex];

                    case 19:
                      questionId = currentQuestion.id;
                      /**
                       * delete all other questions of the group from the distances Map, since only 1 question of a group should be in the final question pool
                       */

                      _iterator6 = _createForOfIteratorHelper(questions);

                      try {
                        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                          _question2 = _step6.value;

                          if (_question2.id !== questionId) {
                            distances["delete"](_question2.id);
                          }
                        }
                      } catch (err) {
                        _iterator6.e(err);
                      } finally {
                        _iterator6.f();
                      }

                    case 22:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop2);
            });

            _iterator4.s();

          case 4:
            if ((_step4 = _iterator4.n()).done) {
              _context3.next = 8;
              break;
            }

            return _context3.delegateYield(_loop2(), "t0", 6);

          case 6:
            _context3.next = 4;
            break;

          case 8:
            _context3.next = 13;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t1 = _context3["catch"](1);

            _iterator4.e(_context3.t1);

          case 13:
            _context3.prev = 13;

            _iterator4.f();

            return _context3.finish(13);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[1, 10, 13, 16]]);
  }));
  return _filterProgressionGroups.apply(this, arguments);
}

function getDistances(_x9, _x10) {
  return _getDistances.apply(this, arguments);
}

function _getDistances() {
  _getDistances = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(categoryId, subjectId) {
    var _initDistances, distances, progressionGroups;

    return _regenerator["default"].wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _initDistances = initDistances(categoryId, subjectId), distances = _initDistances.distances, progressionGroups = _initDistances.progressionGroups;
            syncDistancesWithHistory(categoryId, subjectId, distances, progressionGroups);
            _context4.next = 4;
            return filterProgressionGroups(distances, progressionGroups, categoryId, subjectId);

          case 4:
            state.progressionGroups = progressionGroups;
            return _context4.abrupt("return", distances);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _getDistances.apply(this, arguments);
}

function parseServerDate(date) {
  var parts = date.split(' ');

  if (parts.length === 2) {
    var parts1 = parts[0].split('-');
    var parts2 = parts[1].split(':');

    if (parts1 && parts2) {
      var year = (0, _parseInt2["default"])(parts1[0], 10);
      var month = (0, _parseInt2["default"])(parts1[1], 10);
      var day = (0, _parseInt2["default"])(parts1[2], 10);
      var hours = (0, _parseInt2["default"])(parts2[0], 10);
      var mins = (0, _parseInt2["default"])(parts2[1], 10);
      var secs = (0, _parseInt2["default"])(parts2[2], 10);

      if (year && month && day && hours && mins && secs) {
        var _date = new Date(year, month, day, hours, mins, secs);

        if (_date) {
          return _date.getTime();
        }
      }
    }
  }

  return NaN;
}

function updateQuestionHistory(_x11, _x12, _x13, _x14) {
  return _updateQuestionHistory.apply(this, arguments);
}

function _updateQuestionHistory() {
  _updateQuestionHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(subjectId, categoryId, question, correct) {
    var questionId, path, questionHistory, minCorrectsForLearned, isQuestionGroup, group, existingHistory;
    return _regenerator["default"].wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            questionId = question.id;
            path = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId);
            questionHistory = _DataStore["default"].getElementByPathImmediately("".concat(path, ".").concat(questionId));
            minCorrectsForLearned = 1;
            isQuestionGroup = false;

            if (question.progressionGroup && state.progressionGroups) {
              isQuestionGroup = true;
              group = state.progressionGroups.get(question.progressionGroup);

              if (group && group.length > 0) {
                group = group.sort(function (a, b) {
                  return a.progressionLevel - b.progressionLevel;
                });
                minCorrectsForLearned = group[group.length - 1].progressionLevel;
              }
            } else {
              minCorrectsForLearned = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED) || 1;
            }

            if (!questionHistory) {
              questionHistory = {
                distance: minCorrectsForLearned,
                dateCreated: '',
                question: questionId,
                history: '',
                correct: correct
              };
            }

            questionHistory.downgrade = !correct;
            updateDate(questionHistory);
            updateHistory(questionHistory, correct);
            updateDistance(questionHistory, correct, minCorrectsForLearned, isQuestionGroup);
            existingHistory = _DataStore["default"].getElementByPathImmediately("".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId));
            existingHistory[questionId] = questionHistory;
            _context5.next = 15;
            return _DataStore["default"].setSingleData(path, existingHistory);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _updateQuestionHistory.apply(this, arguments);
}

function updateDate(question) {
  question.dateCreated = new Date().toString();
}

function updateHistory(question, correct) {
  if (question.history.length > MAX_HISTORY) {
    question.history = question.history.substr(1);
  }

  question.history += correct ? 'R' : 'F';
}

function updateDistance(question, correct, minCorrectsForLearned, isQuestionGroup) {
  if (!correct) {
    /**
     * question groups drop down by 1 level only, so distance is increased by one as long as its not already on max
     */
    if (isQuestionGroup && question.distance < minCorrectsForLearned) {
      question.distance += 1;
    }

    question.distance = minCorrectsForLearned;
  } else {
    if (question.distance !== 10) {
      if (isQuestionGroup) {
        question.distance = 10;
      } else {
        question.distance -= 1;
        question.distance = question.distance > 0 ? question.distance : 10;
      }
    }
  }
}

function getProgressionGroupLength(progressionGroupName) {
  var progressionGroups = state.progressionGroups;

  if (progressionGroups) {
    var groupToCheck = progressionGroups.get(progressionGroupName);
    return groupToCheck ? groupToCheck.length : 0;
  }

  return 0;
}

function filterQuestionProgressionGroups(questions) {
  var progressionGroup = state.progressionGroups;
  var progressionGroupQuestions = {};

  if (progressionGroup) {
    progressionGroup.forEach(function (value, key, map) {
      value.forEach(function (singleValue) {
        progressionGroupQuestions[singleValue.id] = singleValue;
      });
    });
  }

  (0, _keys["default"])(questions).forEach(function (questionKey) {
    var question = questions[questionKey];

    if ((0, _keys["default"])(progressionGroupQuestions).indexOf(question.question) !== -1) {
      var maxLevel = (0, _keys["default"])(progressionGroupQuestions).length;
      var progressionGroupQuestion = progressionGroupQuestions[question.question];

      if (progressionGroupQuestion.progressionGroup && question.distance === 10 && progressionGroupQuestion.progressionLevel < maxLevel) {
        delete questions[questionKey];
      }
    }
  });
  return questions;
}

function updateLearningState(_x15, _x16) {
  return _updateLearningState.apply(this, arguments);
}

function _updateLearningState() {
  _updateLearningState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(categoryId, subjectId) {
    var learningStatePath, oldLearningState, defaultDate, actLearned, actTouched, historyPath, history, questions, learningStateClone;
    return _regenerator["default"].wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            learningStatePath = "".concat(_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE_OFFLINE, ".").concat(subjectId, ".").concat(categoryId);
            oldLearningState = _DataStore["default"].getElementByPathImmediately(learningStatePath);

            if (!oldLearningState) {
              _context6.next = 15;
              break;
            }

            defaultDate = new Date(1970, 0, 1).getTime();
            actLearned = 0;
            actTouched = 0;
            historyPath = "".concat(_DataStore.DATA_STORE_PATHS.QD_ALL_HISTORY, ".").concat(subjectId, ".").concat(categoryId);
            history = JSON.parse((0, _stringify["default"])(_DataStore["default"].getElementByPathImmediately(historyPath) || {}));
            questions = filterQuestionProgressionGroups(history);

            if (questions) {
              (0, _values["default"])(questions).forEach(function (question) {
                var date = Date.parse(question.dateCreated);

                if (!date) {
                  date = parseServerDate(question.dateCreated);
                }

                if (question.distance === 10) {
                  actLearned += 1;
                } else if (!isNaN(date) && date !== defaultDate) {
                  actTouched += 1;
                }
              });
            }

            learningStateClone = _objectSpread({}, oldLearningState);
            learningStateClone.learned = actLearned / learningStateClone.questionCount;
            learningStateClone.inProgess = actTouched / learningStateClone.questionCount;
            _context6.next = 15;
            return _DataStore["default"].setSingleData(learningStatePath, learningStateClone);

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));
  return _updateLearningState.apply(this, arguments);
}

var QuizSelectionService = {
  getOrderedQuestionIds: getOrderedQuestionIds,
  updateQuestionHistory: updateQuestionHistory,
  updateLearningState: updateLearningState,
  getHistoryForQuestion: getHistoryForQuestion
};
var _default = QuizSelectionService;
exports["default"] = _default;